import React from 'react';
import BaseIcon from './BaseIcon';


const ShareIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M2,4.12682752 L8,8.51144291 L14,4.12682752 L14,4 L2,4 L2,4.12682752 Z M2,6.60394171 L2,12 L14,12 L14,6.60394171 L8.88502488,10.3418081 C8.3578848,10.7270259 7.6421152,10.7270259 7.11497512,10.3418081 L2,6.60394171 Z M0,2 L16,2 L16,14 L0,14 L0,2 Z" fillRule="nonzero" />
    </g>
  </BaseIcon>
);

export default ShareIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/ShareIcon.jsx